// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C5Fk","questions":"styles_questions__1Xx5X","footer":"styles_footer__2m9ZE"};